<template>
	<mobile-card>
		<template slot="title">
			<div v-if="item.isLock" class="flex-column-center">
				<van-icon name="lock" size="0.43rem" />
				<span style="margin-left: 5px">{{ item.itemName }}</span>
			</div>
			<div v-else>
				<!-- <van-checkbox :value="checked" checked-color="#005423" @click="onChange" icon-size="16px"> -->
				<van-checkbox :value="checked" checked-color="#005423" @click="onChange" icon-size="0.43rem">
					{{ item.itemName }}
				</van-checkbox>
			</div>
		</template>

		<template slot="content">
			<div class="flex-form-info">
				<div class="left">{{ rangeText }}</div>
				<div class="right">{{ item.intervalName }}</div>
			</div>
			<!-- 收费申报 -->
			<van-popup v-model="showSpecPicker" position="bottom">
				<van-picker
					show-toolbar
					:columns="declareStds"
					:default-index="defaultIndex"
					value-key="specDesc"
					@cancel="showSpecPicker = false"
					@confirm="onConfirm"></van-picker>
			</van-popup>
			<div class="flex-form-info" v-if="item.feeMode === 5">
				<div class="left">{{ standardText }}</div>
				<div class="right link" @click="clickSpec">{{ selectedSpec }}</div>
			</div>

			<div class="flex-form-info" v-else>
				<div class="left">{{ receiveText }}</div>
				<div class="right link">{{ item.needMoney | formatMoney }}</div>
			</div>

			<div class="flex-form-info" v-if="showCount">
				<div class="left">{{ countText }}</div>
				<div class="right">
					<van-stepper v-model="specCount" @change="onChangeSpecCount" />
				</div>
			</div>

			<div class="flex-form-info" v-show="hiddenEdit && item.feeMode === 5">
				<div class="left">{{ paymentText }}</div>
				<div class="right">
					<span>{{ moneyShow | formatMoney }}</span>
					<van-icon v-if="can_edit" name="edit" @click="onEdit" />
				</div>
			</div>
			<div class="flex-form-info" v-show="hiddenEdit && item.feeMode !== 5">
				<div class="left">{{ paymentText }}</div>
				<div class="right">
					<span>{{ item.nowMoney | formatMoney }}</span>
					<van-icon v-if="can_edit" name="edit" @click="onEdit" />
				</div>
			</div>

			<div class="flex-form-info" v-show="!hiddenEdit">
				<div class="left">{{ paymentText }}</div>
				<span :data-tootik="editMoneyPlaceholder">
					<vue-numeric
						v-model="item.nowMoney"
						:min="item.minMoney"
						:max="item.needMoney"
						:precision="2"
						class="money-input"
						@change="inputChange"></vue-numeric>
				</span>
			</div>
		</template>
	</mobile-card>
</template>
<script>
import eventBus from '../../eventbus'
import MobileCard from 'components/mobile-card/index'

export default {
	name: 'chargeCard',
	components: { MobileCard },
	props: {
		item: Object,
		selectList: Array
	},
	data() {
		return {
			rangeText: this.$t('unpaid_fee.charge_card.range'),
			standardText: this.$t('unpaid_fee.charge_card.standard'),
			receiveText: this.$t('unpaid_fee.charge_card.receive'),
			countText: this.$t('unpaid_fee.charge_card.count'),
			paymentText: this.$t('unpaid_fee.charge_card.pay'),
			specCount: 1,
			selectedSpec: '请选择',
			defaultIndex: 0,
			hiddenEdit: true,
			checked: false,
			showSpecPicker: false,
			specSelectedPrice: 0,
			moneyShow: 0
		}
	},

	computed: {
		declareStds() {
			if (this.item.feeMode === 5) {
				if (this.item.forceConnDeclareWhenCharge === 1 && this.item.forcePayDeclareWhenCharge === 0) {
					//带出‘自定义收费金额’，自定义金额
					let tempMoneys = []
					this.item.declareStds.forEach(x => {
						if (x.isActive == 1 && x.isSpec === 1) {
							tempMoneys.push(x.specDesc)
						}
					})
					return tempMoneys
				} else if (this.item.forceConnDeclareWhenCharge === 1 && this.item.forcePayDeclareWhenCharge === 1) {
					//带出‘单价固定数量可改’的申报标准,可改数量
					let tempMoneys = []
					this.item.declareStds.forEach(x => {
						if (x.isActive == 1 && x.isSpec === 0) {
							tempMoneys.push({
								specDesc: '(' + x.specPrice + x.specUnit + ')' + x.specDesc,
								specPrice: x.specPrice
							})
						}
					})
					return tempMoneys
				}
			}

			if (this.item.declareStds) {
				return this.item.declareStds.map(x => x.intervalName)
			} else {
				return []
			}
		},
		showCount() {
			return (
				this.item.feeMode === 5 &&
				this.item.forceConnDeclareWhenCharge === 1 &&
				this.item.forcePayDeclareWhenCharge === 1
			)
		},

		can_edit() {
			if (this.item.feeMode === 5) {
				if (this.item.forceConnDeclareWhenCharge === 1 && this.item.forcePayDeclareWhenCharge === 0) {
					return true
				}
			}
			// 20200817 允许应收分次交费，若当前应交<=最低交费，期望不允许修改本次交费金额 bug295
			return this.item.editMoney && this.item.needMoney > this.item.minMoney
		},
		editMoneyPlaceholder() {
			if (this.item.minMoney) {
				return (
					this.$t('unpaid_fee.minMoneyStart') +
					this.$options.filters.formatMoney(this.item.minMoney) +
					this.$t('choose_fee.maxMoneyEnd')
				)
			}
			return null
		}
	},

	created() {
		eventBus.$on('select-all', this.selectAll)
	},

	methods: {
		onConfirm(value, index) {
			if (this.checked) {
				eventBus.$emit('summary-price', { item: this.item, checked: false })
				this.checked = false
			}

			if (this.item.forceConnDeclareWhenCharge === 1 && this.item.forcePayDeclareWhenCharge === 1) {
				this.moneyShow = value.specPrice * this.specCount
				this.item.nowMoney = value.specPrice * this.specCountesc
				this.selectedSpec = value.specDesc
			} else if (this.item.forceConnDeclareWhenCharge === 1 && this.item.forcePayDeclareWhenCharge === 0) {
				this.moneyShow = 0
				this.selectedSpec = value
			}
			this.specSelectedPrice = value.specPrice
			this.showSpecPicker = false
			eventBus.$emit('summary-price', { item: this.item, checked: this.checked })
		},
		clickSpec() {
			this.showSpecPicker = true
		},
		onChangeSpecCount(count) {
			this.item.nowMoney = count * this.specSelectedPrice
			this.moneyShow = count * this.specSelectedPrice
			if (this.checked) {
				eventBus.$emit('summary-price', { item: this.item, checked: this.checked })
			}
		},

		isMutiBank() {
			//是否多个银行
			let isPass = true
			if (!this.checked) {
				this.selectList.forEach(select => {
					if (select.bankAccount !== this.item.bankAccount) {
						isPass = false
					}
				})
			}
			if (!isPass) {
				this.$toast({
					duration: 3000, // 持续展示 toast
					forbidClick: true,
					message: '该收费项目不能与已经选择的其他收费项目一同交费。'
				})
			}
			return !isPass
		},
		onChange() {
			if (this.isMutiBank()) return
			this.checked = !this.checked
			if (
				this.item.feeMode === 5 &&
				this.item.forceConnDeclareWhenCharge === 1 &&
				this.item.forcePayDeclareWhenCharge === 1
			) {
				this.item.nowMoney = this.specCount * this.specSelectedPrice
				this.onChangeSpecCount(this.specCount)
			}
			eventBus.$emit('summary-price', { item: this.item, checked: this.checked })
		},

		inputChange(val) {
			if (val > this.item.needMoney) {
				val = this.item.needMoney
			}
			if (this.checked) {
				eventBus.$emit('summary-price', { item: this.item, checked: this.checked })
			}
		},

		onEdit() {
			this.item.nowMoney = this.item.feeMode === 5 ? 0 : this.item.nowMoney
			console.log(this.item.nowMoney)
			this.hiddenEdit = false
		},

		selectAll(value) {
			this.checked = value
		}
	}
}
</script>
<style lang="scss" scoped></style>
